<template>
  <section class="companies">
    <br>
    <div class="columns">
      <div class="column is-12 is-paddingless">
        <div
          v-for="(company_chunk, idx_chunk) in companies"
          :key="'chunk' + idx_chunk"
        >
          <div class="columns">
            <div
              v-for="(company, idx) in company_chunk"
              :key="idx"
              class="column is-one-quarter-desktop"
            >
              <div
                v-if="company.last_element"
                class="card"
              >
                <div
                  class="card-content flex items-center justify-center"
                >
                  <div class="content has-text-centered">
                    <button
                      type="button"
                      class="button primary"
                      @click="showAddEditModal()"
                    >
                      Activate a new Company
                    </button>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="card"
              >
                <header class="card-header">
                  <h6
                    class="card-header-title is-primary-border has-text-weight-bold"
                  >
                    {{ company.name }}
                  </h6>
                  <div class="card-header-icon">
                    <div class="dropdown">
                      <div class="dropdown-trigger">
                        <button
                          class="button is-white"
                          aria-haspopup="true"
                          aria-controls="dropdown-menu"
                        >
                          <span class="icon is-small">
                            <i
                              class="fas fa-ellipsis-v"
                              aria-hidden="true"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        id="dropdown-menu"
                        class="dropdown-menu"
                        role="menu"
                      >
                        <div class="dropdown-content">
                          <button
                            class="dropdown-item"
                            @click="showEditModal(company)"
                          >
                            Edit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </header>
                <div class="card-content">
                  <div class="content">
                    <span>{{ company.lien_tickets }}</span>
                    <span>{{ company.locations }}</span>
                    <span>{{ company.users }}</span>
                  </div>
                </div>
                <footer class="card-footer">
                  <button
                    class="button is-white is-info is-outlined is-borderless"
                    @click="handleCompanyView(company)"
                  >
                    View
                  </button>
                </footer>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal add-edit-company"
      :class="{ 'is-active': show_add_edit_modal }"
    >
      <div
        class="modal-background"
        @click="hideAddEditModal()"
      />
      <div class="modal-content">
        <div class="box">
          <p class="title">
            {{ isEditMode ? "Edit" : "Add" }} company
          </p>
          <div class="company-info">
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Name</span>
                  <span
                    :data-tooltip="
                      'Required field' + '\n' + 'Allowed character count is 50'
                    "
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="models.name"
                  class="input is-mandatory"
                  :class="errors.name.visible ? 'has-error' : ''"
                  type="text"
                  placeholder="Company name"
                >
                <span v-if="errors.name.visible">{{
                  errors.name.message
                }}</span>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Customer ID</span>
                  <span
                    :data-tooltip="
                      'Required field' + '\n' + 'Allowed character count is 255'
                    "
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="models.customerId"
                  class="input is-mandatory"
                  :class="errors.customerId.visible ? 'has-error' : ''"
                  :disabled="isEditMode ? true : false"
                  type="text"
                  placeholder="Customer ID"
                >
                <span v-if="errors.customerId.visible">{{
                  errors.customerId.message
                }}</span>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Address</span>
                  <span
                    :data-tooltip="
                      'Required field' + '\n' + 'Allowed character count is 50'
                    "
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="models.address"
                  class="input is-mandatory"
                  :class="errors.address.visible ? 'has-error' : ''"
                  placeholder="Address"
                  type="text"
                >
                <span v-if="errors.address.visible">{{
                  errors.address.message
                }}</span>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Phone number</span>
                  <span
                    :data-tooltip="
                      'Required field' + '\n' + 'Only digits are allowed'
                    "
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="models.phone"
                  v-restrict:[restrictValue]="models.phone"
                  class="input phone-input is-mandatory"
                  :class="errors.phone.visible ? 'has-error' : ''"
                  placeholder="Phone number"
                  type="text"
                >
                <span v-if="errors.phone.visible">{{
                  errors.phone.message
                }}</span>
              </div>
            </div>
            <div
              v-if="!isEditMode"
              class="field"
            >
              <div class="control">
                <label class="label">
                  <span>Email</span>
                  <span
                    :data-tooltip="
                      'Required field' +
                        '\n' +
                        'Allowed character count is 100' +
                        '\n' +
                        'Should be valid'
                    "
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="models.email"
                  class="input email-input is-mandatory"
                  :class="errors.email.visible ? 'has-error' : ''"
                  placeholder="Email address"
                  type="text"
                >
                <span v-if="errors.email.visible">{{
                  errors.email.message
                }}</span>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Sender Name</span>
                  <span
                    :data-tooltip="'Allowed character count is 50'"
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="models.senderName"
                  class="input"
                  :class="errors.senderName.visible ? 'has-error' : ''"
                  type="text"
                  placeholder="Sender name"
                >
                <span v-if="errors.senderName.visible">{{
                  errors.senderName.message
                }}</span>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Sender Email</span>
                  <span
                    :data-tooltip="
                      'Allowed character count is 100' + '\n' + 'Should be valid'
                    "
                    class="tooltip has-tooltip-right has-tooltip-arrow"
                  >
                    <img
                      src="../../../public/assets/img/info.svg"
                      alt=""
                    >
                  </span>
                </label>
                <input
                  v-model="models.fromEmail"
                  class="input email-input"
                  :class="errors.fromEmail.visible ? 'has-error' : ''"
                  placeholder="Email address"
                  type="text"
                >
                <span v-if="errors.fromEmail.visible">{{
                  errors.fromEmail.message
                }}</span>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Corp Code</span>
                </label>
                <input
                  v-model="models.corpCode"
                  class="input"
                  :class="errors.corpCode.visible ? 'has-error' : ''"
                  placeholder="Corp Code"
                  type="text"
                >
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Corp User Name</span>
                </label>
                <input
                  v-model="models.corpUserName"
                  class="input"
                  :class="errors.corpUserName.visible ? 'has-error' : ''"
                  placeholder="Corp User Name"
                  type="text"
                >
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Api Key</span>
                </label>
                <input
                  v-model="models.apiKey"
                  class="input"
                  :class="errors.apiKey.visible ? 'has-error' : ''"
                  placeholder="Api Key"
                  type="text"
                >
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Corp Password</span>
                </label>
                <input
                  v-model="models.corpPassword"
                  class="input"
                  :class="errors.corpPassword.visible ? 'has-error' : ''"
                  placeholder="Corp Password"
                  type="text"
                >
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Storedgefms Api Key</span>
                </label>
                <input
                  v-model="models.fms_api_key"
                  class="input"
                  :class="errors.fms_api_key.visible ? 'has-error' : ''"
                  placeholder="Storedgefms Api Key"
                  type="text"
                >
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">
                  <span>Storedgefms Api Secret</span>
                </label>
                <input
                  v-model="models.fms_api_secret"
                  class="input"
                  :class="errors.fms_api_secret.visible ? 'has-error' : ''"
                  placeholder="Storedgefms Api Secret"
                  type="text"
                >
              </div>
            </div>
            <div class="field checkbox">
              <input
                id="sendStatus"
                v-model="models.sendStatus"
                type="checkbox"
                :checked="models.sendStatus"
                :value="models.sendStatus"
              >
              <label for="sendStatus">Send status</label>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Invoicing Type</label>
                <div class="select is-fullwidth">
                  <div class="select-container">
                    <select
                      v-model="models.invoicingType"
                      required
                    >
                      <option
                        selected
                        value=""
                      >
                        Select option
                      </option>
                      <option value="per_customer">
                        Per Costumer
                      </option>
                      <option value="per_location">
                        Per Location
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Invoice date</label>
                <input
                  v-model="models.invoiceDate"
                  class="input"
                  placeholder="Invoice Date"
                  type="text"
                >
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Service period</label>
                <div class="select is-fullwidth">
                  <div class="select-container">
                    <select
                      v-model="models.servicePeriod"
                      required
                    >
                      <option
                        selected
                        value=""
                      >
                        Select option
                      </option>
                      <option value="last_month">
                        Last Month
                      </option>
                      <option value="next_month">
                        Next Month
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Payment term</label>
                <input
                  v-model="models.paymentTerm"
                  class="input"
                  placeholder="Payment term"
                  type="number"
                >
              </div>
            </div>
            <div
              class="field"
            >
              <vc-date-picker
                v-model="models.contractDuration"
                class="vc-datepicker control"
                mode="dateTime"
                :timezone="timezone"
                :popover="{ visibility: 'click' }"
                is-range
              >
                <template #default="{ inputValue, inputEvents }">
                  <div class="picker d-column field control">
                    <div class="picker-input">
                      <span class="lien-box-label">Contract duration Start date</span>
                      <input
                        readonly
                        :value="inputValue.start"
                        class="w-full input border px-2 py-1 w-32 lien-box-val rounded focus:outline-none focus:border-indigo-300"
                        v-on="inputEvents.start"
                      >
                    </div>
                    <div class="picker-input d-column field control">
                      <span class="lien-box-label">Contract duration End date</span>
                      <input
                        readonly
                        :value="inputValue.end"
                        class="w-full input border px-2 py-1 w-32 lien-box-val rounded focus:outline-none focus:border-indigo-300"
                        v-on="inputEvents.end"
                      >
                    </div>
                  </div>
                </template>
              </vc-date-picker>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Contract attachment</label>
                <div class="upload-image">
                  <input
                    id="file-input"
                    ref="contractAttachment"
                    type="file"
                    accept="image/*, application/pdf"
                    class="button is-outlined file-uploader"
                    multiple
                    @change="uploadImage"
                  >
                  <div
                    v-for="(image, index) in imagesPfs"
                    :key="image.id"
                    class="mt-4"
                  >
                    <div
                      v-if="isImage(image.aws_link) || image.type?.includes('image')"
                      class="my-5 mx-0 flex items-center"
                    >
                      <img
                        :src="image.aws_link || createImageUrl(image)"
                        alt="img"
                        class="image-preview mr-1 h-[200px]"
                      >
                      <span
                        class="icon cursor-pointer"
                        @click="deleteImage(index)"
                      ><i
                        class="fas fa-times"
                        aria-hidden="true"
                      /></span>
                    </div>
                    <div
                      v-else-if="image.aws_link && isPdf(image.aws_link) || image.type?.includes('pdf')"
                      class="my-5 mx-5 mr-0 flex items-center"
                    >
                      <span v-if="image.name">{{ image.name }}</span>
                      <span v-if="image.aws_link">{{ createFileNameFromUrl(image) }}</span>
                      <a
                        class="button primary-light ml-1"
                        target="_blank"
                        :href="image.aws_link || createImageUrl(image)"
                      > Download</a>
                      <span
                        class="icon cursor-pointer"
                        @click="deleteImage(index)"
                      ><i
                        class="fas fa-times"
                        aria-hidden="true"
                      /></span>
                    </div>
                    <div
                      v-else-if="!image.name && image.aws_link"
                      class="not_uploaded"
                    >
                      {{ createFileNameFromUrl(image) }}
                      <span
                        class="icon cursor-pointer"
                        @click="deleteImage(index)"
                      ><i
                        class="fas fa-times"
                        aria-hidden="true"
                      /></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Special invoicing request</label>
                <textarea
                  v-model="models.specialInvoicingRequest"
                  class="input is-mandatory"
                  placeholder="Special invoicing request"
                />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Finance and Admin Fee</label>
                <textarea
                  v-model="models.financeAndAdminFee"
                  class="input is-mandatory"
                  placeholder="Finance and Admin Fee"
                />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Auction site</label>
                <div class="select is-fullwidth">
                  <div class="select-container">
                    <select
                      v-model="models.auctionSite"
                      required
                    >
                      <option
                        selected
                        value=""
                      >
                        Select option
                      </option>
                      <option value="storage_auction">
                        Storage Auctions
                      </option>
                      <option value="storage_treasures">
                        Storage Treasures
                      </option>
                      <option value="self_storage_auctions">
                        Self Storage Auctions
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Key decision maker(s)</label>
                <textarea
                  v-model="models.keyDecisionMaker"
                  class="input is-mandatory"
                  placeholder="Key decision maker(s)"
                />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Legal counsel</label>
                <textarea
                  v-model="models.legalCounsel"
                  class="input is-mandatory"
                  placeholder="Legal counsel"
                />
              </div>
            </div>
            <div class="field">
              <div class="control">
                <label class="label">Notes</label>
                <textarea
                  v-model="models.notes"
                  class="input is-mandatory"
                  placeholder="Notes"
                />
              </div>
            </div>

            <vc-date-picker
              v-model="models.expirationDate"
              :timezone="timezone"
              :is-dark="isDark"
              :min-date="today"
            >
              <template #default="{ inputValue, inputEvents }">
                <al-input
                  readonly
                  :value="inputValue"
                  label="Expiration date"
                  date-picker
                  v-on="inputEvents"
                />
              </template>
            </vc-date-picker>
          </div>
          <div class="modal-actions control">
            <div class="space-x-2">
              <button
                type="button"
                class="button is-outlined"
                @click="hideAddEditModal()"
              >
                Cancel
              </button>
              <al-button
                v-if="isEditMode"
                outlined
                danger
                @click="discontinueConfirmDialog = true"
              >
                Discontinue
              </al-button>
            </div>

            <button
              type="button"
              class="button primary"
              @click="addEditCompany()"
            >
              {{ isEditMode ? "Save" : "Create" }}
            </button>
          </div>
        </div>
      </div>
      <button
        class="modal-close is-large"
        aria-label="close"
        @click="hideAddEditModal()"
      />
    </div>

    <al-dialog
      v-model="discontinueConfirmDialog"
      title="Discontinue Company"
    >
      <h5 class="text-danger">
        Caution!
      </h5>
      <p class="text-sm">
        <b>This action cannot be undone.</b><br>
        Are you sure you want to discontinue <b>{{ models.name }}</b> company?
      </p>
      <template #actions>
        <al-button @click="discontinueConfirmDialog = false">
          Cancel
        </al-button>
        <al-button
          danger
          :loading="loading"
          @click="discontinueCompany()"
        >
          Yes, I'm Sure
        </al-button>
      </template>
    </al-dialog>
  </section>
</template>
<script>
/* eslint-disable camelcase */

import UserService from '../../services/user.service';
import {
  isValidEmail, isImage, isPdf, isValidSize
} from '@/utils/validationUtils';
import { formattedDate } from '@/utils/dateUtil';

const userService = new UserService();

const defaultErrors = {
  name: {
    visible: false,
    message: ''
  },
  customerId: {
    visible: false,
    message: ''
  },
  address: {
    visible: false,
    message: ''
  },
  phone: {
    visible: false,
    message: ''
  },
  email: {
    visible: false,
    message: ''
  },
  fromEmail: {
    visible: false,
    message: ''
  },
  corpCode: {
    visible: false,
    message: ''
  },
  corpUserName: {
    visible: false,
    message: ''
  },
  apiKey: {
    visible: false,
    message: ''
  },
  corpPassword: {
    visible: false,
    message: ''
  },
  fms_api_secret: {
    visible: false,
    message: ''
  },
  fms_api_key: {
    visible: false,
    message: ''
  },
  senderName: {
    visible: false,
    message: ''
  }
};
const defaultModels = {
  name: '',
  customerId: '',
  address: '',
  phone: '',
  email: '',
  fromEmail: '',
  senderName: '',
  corpUserName: '',
  corpCode: '',
  corpPassword: '',
  apiKey: '',
  fms_api_key: '',
  fms_api_secret: '',
  sendStatus: false,
  invoicingType: '',
  invoiceDate: '',
  servicePeriod: '',
  paymentTerm: '',
  contractDuration: {
    start: '',
    end: ''
  },
  expirationDate: '',
  specialInvoicingRequest: '',
  financeAndAdminFee: '',
  auctionSite: '',
  keyDecisionMaker: '',
  legalCounsel: '',
  notes: ''
};

export default {
  name: 'CompaniesComponent',
  data() {
    return {
      companies: [],
      show_add_edit_modal: false,
      isEditMode: false,
      selectedCompany: null,
      restrictValue: '[0-9]',
      errors: { ...defaultErrors },
      models: { ...defaultModels },
      imagesPfs: [],
      timezone: '',
      discontinueConfirmDialog: false,
      loading: false,
      today: new Date()
    };
  },
  computed: {
    isDark() {
      return this.$store.getters['common/getDarkMode'];
    }
  },
  mounted() {
    this.getCompanies();
    this.isImage = isImage.bind(this);
    this.isPdf = isPdf.bind(this);
  },
  methods: {
    createFileNameFromUrl(file) {
      const lastSlashIndex = file.aws_link?.lastIndexOf('/');
      return lastSlashIndex !== -1 ? file.aws_link?.slice(lastSlashIndex + 1) : null;
    },
    createImageUrl(file) {
      return URL.createObjectURL(file);
    },
    uploadImage(event) {
      const { files } = event.target; // Get the selected files
      const fileList = Array.from(files);

      fileList.forEach((file) => {
        if (!isImage(file.name) && !isPdf(file.name)) {
          this.$root.$emit('showToast', {
            message: 'Only images or pdfs are allowed to be uploaded',
            options: { cssClass: 'is-danger', duration: 5000 }
          });
          this.$refs.contractAttachment.value = '';
          return;
        }
        if (!isValidSize(file.size, 10)) {
          this.$root.$emit('showToast', {
            message: 'File size is too big. Please choose the smaller file',
            options: { cssClass: 'is-danger', duration: 5000 }
          });
          this.$refs.contractAttachment.value = '';
          return;
        }
        this.imagesPfs.push(file);
        this.$refs.contractAttachment.value = null;
      });
    },
    deleteImage(index) {
      this.imagesPfs = this.imagesPfs.filter(
        (_, indexToCompare) => index !== indexToCompare
      );
    },
    getCompanies() {
      const self = this;

      userService
        .getOrganizations()
        .then((response) => {
          const organizationData = response.data;
          const { status: organizationStatus, result: organizationResult } = organizationData;

          if (organizationStatus === 'success') {
            const sortedOrganization = organizationResult
              // eslint-disable-next-line no-nested-ternary
              .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));
            const companies = [...sortedOrganization, { last_element: true }];
            const { organizationToEdit } = self.$store.state;
            self.companies = self.chunk(companies, 4);
            self.$store.commit('setOrganizations', {
              result: sortedOrganization
            });

            if (organizationToEdit) {
              self.showEditModal(organizationToEdit);
              self.$store.commit('setOrganizationToEdit', { result: null });
            }
          } else {
            self.$root.$emit('showToast', {
              message:
                'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    chunk(arr, chunk) {
      let i;
      let j;
      const temp = [];
      for (i = 0, j = arr.length; i < j; i += chunk) {
        temp.push(arr.slice(i, i + chunk));
      }
      return temp;
    },
    handleCompanyView(organization) {
      this.$store.commit('setSelectedOrganization', { organization });
      this.$router.push({ name: 'company' });
    },
    showAddEditModal() {
      if (this.isEditMode && this.selectedCompany) {
        const {
          name,
          address,
          phone,
          admin_email,
          email,
          from_name,
          send_status,
          corp_code,
          corp_user_name,
          corp_password,
          api_key,
          fms_api_key,
          fms_api_secret,
          short_code,
          invoice_date,
          invoicing_type,
          service_period,
          payment_term,
          contract_duration_start,
          contract_duration_end,
          expiration_date,
          customer_attachments,
          special_invoicing_request,
          finance_and_admin_fee,
          auction_site,
          key_decision_maker,
          legal_counsel,
          notes
        } = this.selectedCompany;

        this.models = {
          ...this.models,
          name: name || '',
          customerId: short_code || '',
          address: address || '',
          phone: phone || '',
          email: admin_email || '',
          fromEmail: email || '',
          senderName: from_name || '',
          corpCode: corp_code || '',
          corpUserName: corp_user_name || '',
          corpPassword: corp_password || '',
          apiKey: api_key || '',
          sendStatus: Number(send_status),
          fms_api_key: fms_api_key || '',
          fms_api_secret: fms_api_secret || '',
          invoicingType: invoicing_type || '',
          invoiceDate: invoice_date || '',
          servicePeriod: service_period || '',
          paymentTerm: payment_term || '',
          contractDuration: {
            start: contract_duration_start || '',
            end: contract_duration_end || ''
          },
          expirationDate: expiration_date || '',
          specialInvoicingRequest: special_invoicing_request || '',
          financeAndAdminFee: finance_and_admin_fee || '',
          auctionSite: auction_site || '',
          keyDecisionMaker: key_decision_maker || '',
          legalCounsel: legal_counsel || '',
          notes: notes || ''
        };
        this.imagesPfs = customer_attachments;
      }
      this.show_add_edit_modal = true;
    },
    hideAddEditModal() {
      this.show_add_edit_modal = false;
      this.resetCompanyInfo();
    },
    showEditModal(company) {
      this.isEditMode = true;
      this.selectedCompany = company;
      this.showAddEditModal();
    },
    addEditCompany() {
      const self = this;
      const {
        name,
        address,
        phone,
        email,
        fromEmail,
        senderName,
        sendStatus,
        corpCode,
        corpUserName,
        corpPassword,
        apiKey,
        fms_api_key,
        fms_api_secret,
        customerId,
        invoicingType,
        invoiceDate,
        servicePeriod,
        paymentTerm,
        contractDuration,
        expirationDate,
        specialInvoicingRequest,
        financeAndAdminFee,
        auctionSite,
        keyDecisionMaker,
        legalCounsel,
        notes
      } = this.models;
      const { isEditMode } = this;
      const isValid = this.validateCompany();

      if (!isValid) {
        return;
      }

      const data = new FormData();

      data.append('name', name);
      data.append('address', address);
      data.append('phone', phone);
      data.append('send_status', Number(sendStatus));
      data.append('email', fromEmail.toLowerCase());
      data.append('corp_code', corpCode);
      data.append('corp_user_name', corpUserName);
      data.append('corp_password', corpPassword);
      data.append('api_key', apiKey);
      data.append('from_name', senderName);
      data.append('fms_api_key', fms_api_key);
      data.append('fms_api_secret', fms_api_secret);
      data.append('short_code', customerId);
      data.append('invoicing_type', invoicingType ?? null);
      data.append('service_period', servicePeriod ?? null);
      data.append('payment_term', paymentTerm);
      data.append('special_invoicing_request', specialInvoicingRequest);
      data.append('finance_and_admin_fee', financeAndAdminFee);
      data.append('auction_site', auctionSite ?? null);
      data.append('key_decision_maker', keyDecisionMaker);
      data.append('legal_counsel', legalCounsel);
      data.append('notes', notes);
      if (invoiceDate) {
        data.append('invoice_date', invoiceDate);
      }
      if (contractDuration.start) {
        data.append('contract_duration_start', formattedDate(contractDuration.start));
      }
      if (contractDuration.end) {
        data.append('contract_duration_end', formattedDate(contractDuration.end));
      }
      if (expirationDate) {
        data.append('expiration_date', expirationDate);
      }

      this.imagesPfs.forEach((item, index) => {
        let file;

        if (typeof item === 'object' && item.aws_link) {
          file = JSON.stringify(item);
        } else {
          file = item;
        }
        data.append(`contract_attachment_${index}`, file);
      });

      if (!isEditMode) {
        data.append('email_admin', email);
      }

      let companyAction = () => userService.createOrganization(data);

      if (isEditMode) {
        companyAction = () => userService.updateOrganization(data, this.selectedCompany.uuid);
      }

      companyAction()
        .then((response) => {
          const { status, message } = response.data;

          if (status === 'success') {
            self.$root.$emit('showToast', {
              message:
                message
                || `Company successfully ${isEditMode ? 'updated' : 'created'}`,
              options: { cssClass: 'is-success', duration: 5000 }
            });
            self.hideAddEditModal();
            self.getCompanies();
          } else {
            self.$root.$emit('showToast', {
              message:
                message
                || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
              options: { cssClass: 'is-danger', duration: 10000 }
            });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', {
            message:
              'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });
        });
    },
    async discontinueCompany() {
      try {
        this.loading = true;

        const { data: { status, message } } = await userService.discontinuesOrganization(this.selectedCompany.uuid);

        if (status === 'success') {
          this.$root.$emit('showToast', {
            message: 'Company successfully discontinued',
            options: { cssClass: 'is-success', duration: 5000 }
          });

          this.getCompanies();
          this.hideAddEditModal();
          this.discontinueConfirmDialog = false;
        } else {
          this.$root.$emit('showToast', {
            message:
              message
              || 'Impossible to perform this action. Be sure to be connected and to have access to this action',
            options: { cssClass: 'is-danger', duration: 10000 }
          });

          throw new Error(message);
        }
      } catch (error) {
        console.error('[Companies] discontinueCompany', error);
      } finally {
        this.loading = false;
      }
    },
    validateCompany() {
      const {
        name, address, phone, email, fromEmail, senderName, customerId
      } = this.models;

      const nameError = {
        visible: false,
        message: ''
      };
      const customerIdError = {
        visible: false,
        message: ''
      };
      const addressError = {
        visible: false,
        message: ''
      };
      const phoneError = {
        visible: false,
        message: ''
      };
      const emailError = {
        visible: false,
        message: ''
      };
      const fromEmailError = {
        visible: false,
        message: ''
      };
      const senderNameError = {
        visible: false,
        message: ''
      };

      let message = '';

      if (!name) {
        message += 'Company name is required <br>';
        nameError.visible = true;
        nameError.message = 'Company name is required';
      } else if (name.length > 50) {
        message += 'Allowed character count is 50 for Company name<br >';
        nameError.visible = true;
        nameError.message = 'Allowed character count is 50';
      }

      if (!customerId) {
        message += 'Customer ID is required <br>';
        customerIdError.visible = true;
        customerIdError.message = 'Customer ID is required';
      } else if (customerId.length > 255) {
        message += 'Allowed character count is 255 for Customer ID<br >';
        customerIdError.visible = true;
        customerIdError.message = 'Allowed character count is 255';
      }

      if (senderName.length > 50) {
        message += 'Allowed character count is 50 for Sender name<br >';
        senderNameError.visible = true;
        senderNameError.message = 'Allowed character count is 50';
      }

      if (!address) {
        message += 'Address is required <br>';
        addressError.visible = true;
        addressError.message = 'Address is required';
      } else if (address.length > 50) {
        message += 'Allowed character count is 50 for Address<br >';
        addressError.visible = true;
        addressError.message = 'Allowed character count is 50';
      }

      if (!phone) {
        message += 'Phone number is required<br >';
        phoneError.visible = true;
        phoneError.message = 'Phone number is required';
      } else if (phone.length > 50) {
        message += 'Allowed character count is 50 for Phone number<br >';
        phoneError.visible = true;
        phoneError.message = 'Allowed character count is 50';
      }

      if (!this.isEditMode) {
        if (!email) {
          message += 'Email address is required<br >';
          emailError.visible = true;
          emailError.message = 'Email address is required';
        } else if (email.length > 100) {
          message += 'Allowed character count is 100 for Email address<br >';
          emailError.visible = true;
          emailError.message = 'Allowed character count is 100';
        } else if (!isValidEmail(email)) {
          message += 'Please provide a valid email<br >';
          emailError.visible = true;
          emailError.message = 'Email is invalid';
        }
      }

      if (fromEmail.length > 100) {
        message
          += 'Allowed character count is 100 for sender Email address<br >';
        fromEmailError.visible = true;
        fromEmailError.message = 'Allowed character count is 100';
      } else if (fromEmail.length && !isValidEmail(fromEmail)) {
        message += 'Please provide a valid email for sender<br >';
        fromEmailError.visible = true;
        fromEmailError.message = 'Email is invalid';
      }

      this.errors = {
        ...this.errors,
        name: nameError,
        address: addressError,
        phone: phoneError,
        email: emailError,
        fromEmail: fromEmailError,
        senderName: senderNameError,
        customerId: customerIdError
      };
      const isValid = !message.length;

      if (!isValid) {
        this.$root.$emit('showToast', {
          message,
          options: { cssClass: 'is-danger', duration: 30000 }
        });
      }
      return isValid;
    },
    resetCompanyInfo() {
      this.models = { ...defaultModels };
      this.errors = { ...defaultErrors };
      this.isEditMode = false;
      this.selectedCompany = null;
    }
  }
};
</script>
<style
  scoped
  src="../../../public/assets/css/bulma-extension/bulma-tooltip.min.css"
></style>
<style scoped lang="scss">
.companies {
  .is-borderless {
    border: 0;
  }

  .card {
    height: 100%;
    display: flex;
    flex-direction: column;

    .card-header {
      .card-header-title {
        border-left-width: 4px;
        border-left-style: solid;
      }
    }

    .card-content {
      height: 100%;
      padding-top: 3rem;
      padding-bottom: 2.5rem;
      line-height: 2rem;
    }

    .card-footer {
      text-align: right;
      display: block;
      padding: 1rem;
    }
  }

  .add-edit-company {
    .modal-content {
      .box {
        .title {
          font-size: 24px;
          font-weight: bold;
          margin: 0;
        }

        .company-info {
          margin-top: 25px;

          .checkbox {
            display: flex;
            align-items: center;

            label {
              margin-left: 10px;
            }
          }
        }

        .modal-actions {
          display: flex;
          justify-content: space-between;
          margin-top: 25px;

          .button {
            width: 120px;
          }
        }
      }
    }
  }
}
.d-column{
  flex-direction: column;
  align-items: flex-start;
}
.picker-input{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.lien-box-label{
  line-height: 15px;
  font-weight: 400;
  font-size: 0.8rem;
  color: #363636;
}
</style>
